
export type InternalServerErrorResponse = {
  error?: string;
  message?: string;
  timestamp?: string;
};
